import Vue from 'vue'
import Axios from 'axios'
import { isString } from 'util'

// 请求时带上cookies
Axios.defaults.withCredentials = true

// application/x-www-form-urlencoded和application/json格式数据的处理
Axios.defaults.transformRequest = [
    function(data, headers) {
        if (
            (!headers['Content-Type'] ||
                headers['Content-Type'].includes(
                    'application/x-www-form-urlencoded'
                )) &&
            typeof data == 'object'
        ) {
            let ret = ''
            for (let it in data) {
                let value = data[it]
                if (!isString(value)) {
                    value = JSON.stringify(value)
                }
                ret +=
                    encodeURIComponent(it) +
                    '=' +
                    encodeURIComponent(value) +
                    '&'
            }
            ret = ret.slice(0, -1)
            return ret
        }
        if (headers['Content-Type'] == 'application/json' && !isString(data)) {
            return JSON.stringify(data)
        }
        return data
    }
]

Vue.prototype.$axios = Axios
